import React, {useState, useEffect} from 'react';
import {ApolloClient} from '@apollo/client/core';
import {ApolloProvider, from} from '@apollo/client';

import {onError} from '@apollo/client/link/error';

import localForage from 'localforage';
import {persistCache, LocalForageWrapper} from 'apollo3-cache-persist';
// import {useSyncUnsyncedActions} from 'data/queries/actions';
import cache from './apollo-cache';
import {useApolloLoaderContext} from './apollo-loading-context';

async function initializeApollo() {
  await persistCache({
    cache,
    storage: new LocalForageWrapper(localForage),
    maxSize: false,
  });

  // const httplink = new HttpLink({
  //   uri: process.env.GATSBY_MAKESCHOOL_GRAPHQL_ENDPOINT,
  //   credentials: 'include',
  // });
  //
  // Log any GraphQL errors or network error that occurred
  const errorlink = onError(({graphQLErrors, networkError}) => {
    if (graphQLErrors)
      graphQLErrors.map(({message, locations, path}) =>
        // eslint-disable-next-line no-console
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      );
    // eslint-disable-next-line no-console
    if (networkError) console.log(`[Network error]: ${networkError}`);
  });

  return new ApolloClient({
    cache,
    link: from([errorlink]),
  });
}

const useApolloClient = setApolloLoading => {
  const [client, setClient] = useState();
  useEffect(() => {
    initializeApollo()
      .then(apolloClient => {
        setClient(apolloClient);
      })
      .then(() => {
        setApolloLoading(false);
      });
  }, []);
  return client;
};

const OfflineSync = ({children}) => {
  // const sync = useSyncUnsyncedActions();
  // useEffect(() => {
  //   if (navigator.onLine) {
  //     sync();
  //   }
  //   // whether or not we're online, try to sync whenever we come online
  //   window.addEventListener('online', sync);
  //   return () => window.removeEventListener('online', sync);
  // }, []);
  return <>{children}</>;
};

const WithApollo = ({children}) => {
  const {setApolloLoading} = useApolloLoaderContext();
  const client = useApolloClient(setApolloLoading);
  if (!client) {
    return children;
  }
  return (
    <ApolloProvider client={client}>
      <OfflineSync>{children}</OfflineSync>
    </ApolloProvider>
  );
};

export {WithApollo, cache};
